import { Button, DynamicContent, IconRow } from 'components'

import { MdOutlineReportGmailerrorred } from 'react-icons/md'
import { BsArrowRightSquareFill } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import { useDynamicFormContent, useOneStop } from 'hooks'

const REGISTER_URL = 'https://vote.pa/register/#0'
export const FailureScreen = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: `statusLookupForm.failureScreen`,
  })
  const { isOneStop, goToMailInBallot, goToPlanToVote, updateRegistration } =
    useOneStop()
  const {
    formContent,
    registrationDeadlinePassed,
    mailinBallotDeadlinePassed,
  } = useDynamicFormContent()
  const overrideContent =
    formContent?.formOverrides?.['status-lookup']?.error?.bottom
  const dates = formContent?.dates
  return (
    <div>
      <IconRow
        icon={MdOutlineReportGmailerrorred}
        iconColor="red"
        text={t('noMatchingRegistration')}
        iconPadding={14}
      ></IconRow>
      {!registrationDeadlinePassed && (
        <IconRow
          icon={BsArrowRightSquareFill}
          iconColor="blue"
          text={t('stillTime')}
        ></IconRow>
      )}
      {overrideContent ? (
        <DynamicContent data={overrideContent} />
      ) : (
        <>
          {!registrationDeadlinePassed && (
            <div style={{ marginTop: 30, marginBottom: 40 }}>
              <Button
                label={t('registerButton')}
                onClick={() => {
                  if (isOneStop) {
                    updateRegistration()
                  } else {
                    window.location.href = REGISTER_URL
                  }
                }}
                fullWidth={false}
              />
            </div>
          )}

          {/* <p>{t('note1')}</p> */}
          {/* <p dangerouslySetInnerHTML={{ __html: t('note2') }}></p> */}
          <p
            style={{ fontSize: registrationDeadlinePassed ? 16 : 18 }}
            dangerouslySetInnerHTML={{ __html: t('bottomNote') }}
          ></p>
          {registrationDeadlinePassed && !mailinBallotDeadlinePassed && (
            <p
              dangerouslySetInnerHTML={{
                __html: t('deadlinePassedOnlyRegistration', {
                  electionDay: dates?.electionDay,
                }),
              }}
            />
          )}
          {registrationDeadlinePassed && mailinBallotDeadlinePassed && (
            <p
              dangerouslySetInnerHTML={{
                __html: t('deadlinePassed', {
                  electionDay: dates?.electionDay,
                }),
              }}
            />
          )}
        </>
      )}
    </div>
  )
}
